var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "table" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: { data: _vm.tableData.list },
          },
          [
            _c("el-table-column", {
              attrs: { type: "index", label: "序号", width: "55" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "productId", label: "产品编号", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "productName",
                label: "产品名称",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "name", label: "价格形式", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "value", label: "值", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "supplierName", label: "供应商", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "status", label: "状态", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "createdAt", label: "添加时间", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "executionTime",
                label: "执行时间",
                align: "center",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "page" },
      [
        _c("el-pagination", {
          attrs: {
            "page-sizes": [20, 30, 45, 60],
            "page-size": _vm.pageFrom.limit,
            "current-page": _vm.pageFrom.page,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _vm.tableData.total,
          },
          on: {
            "size-change": _vm.handleSizeChange,
            "current-change": _vm.pageChange,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }